import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import config from 'config'

import useSnackbar from '../Snackbar/useSnackbar'

const useInventory = () => {
  const { t } = useTranslation()
  const { showSnackbarMessage } = useSnackbar()

  const [state, setState] = useState({
    isFetching: false,
    isUpdating: false,
    error: null,
  })

  // const setStartFetching = useCallback(() => {
  //   setState((s) => ({
  //     ...s,
  //     isFetching: true,
  //     isUpdating: false,
  //   }))
  // }, [setState])

  // const setStopFetching = useCallback(
  //   (error) => {
  //     setState((s) => ({
  //       ...s,
  //       isFetching: false,
  //       error: error || null,
  //     }))
  //   },
  //   [setState]
  // )

  const setStartUpdating = useCallback(() => {
    setState((s) => ({
      ...s,
      isFetching: false,
      isUpdating: true,
    }))
  }, [setState])

  const setStopUpdating = useCallback(() => {
    setState((s) => ({
      ...s,
      isUpdating: false,
    }))
  }, [setState])

  // const setSuccessFetching = useCallback(
  //   (data) => {
  //     setState((s) => ({
  //       ...s,
  //       isFetching: false,
  //       isUpdating: false,
  //       ...data,
  //       error: null,
  //     }))
  //   },
  //   [setState]
  // )

  const updateInventory = useCallback(
    async (action, items, data) => {
      setStartUpdating()

      try {
        await axios.patch(`${config.apiBaseUrl}inventory/${action}`, {
          items,
          ...data,
        })
        setStopUpdating()
        // setSuccessFetching(result.data.body)
      } catch (e) {
        const message =
          e.response?.data?.message ||
          t('common.error.fetchData', {
            attribute: e.response?.status,
          })

        setStopUpdating()

        showSnackbarMessage({
          severity: 'error',
          message,
        })
      }
    },
    [setStartUpdating, setStopUpdating, showSnackbarMessage, t]
  )

  return {
    // isFetching: state.isFetching,
    isUpdating: state.isUpdating,
    // error: state.error,
    updateInventory,
  }
}

export default useInventory
